import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AddButton } from '_components';
import styles from './Common.module.css';
import { PatientCareCenterNoteGoalsLTGDetails } from './LTGDetails';
class PatientCareCenterNoteGoalsLTGs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: '-1',
        }
    };

    addGoal() {

        if (this.state.selectedDate !== '-1' && this.state.selectedDate !== '0') {
            var goalDate = new Date();
            goalDate.setDate(goalDate.getDate() + parseInt(this.state.selectedDate));
            this.props.addGoal(this.props.noteId, undefined, undefined, goalDate.toISOString().split('T')[0]);
        } else {
            this.props.addGoal(this.props.noteId);
        }
        if (!this.props.goalsUpdated && this.props.noteType !== 1) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    convertNote() {
        this.props.convertNote(this.props.noteId, 5); // PN/DN
    }

    render() {

        return (
            <div>
                    <div className={styles.goal_header}>
                    <div className={styles.stg_header_row}>
                        <span className={styles.add_button_wrapper}>
                                <AddButton size='extra-small' title={'Long Term Goals'} onClick={() => this.addGoal()} disabled={this.props.disabled} />
                        </span>
                    <div className={styles.stg_header_1}>Long Term Goals</div>
                    
                </div>

                        {Object.keys(this.props.allGoals)
                            .map(key => {
                                const result = this.props.allGoals[key];
                                return (
                                    <PatientCareCenterNoteGoalsLTGDetails key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>
            
            </div >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addGoal: bindActionCreators(noteActions.addGoal, dispatch),
        addCustomGoal: bindActionCreators(noteActions.addCustomGoal, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        convertNote: bindActionCreators(noteActions.convert, dispatch),
        updateDateField: bindActionCreators(noteActions.updateDateField, dispatch),
        updateDatesLTG: bindActionCreators(noteActions.updateDatesLTG, dispatch),
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWc = state.entities.admissions[epno].isWc;
    let disabled = true;

    let isTemplateVisible = false;

    if (Object.keys(state.entities.notes.PTGOALTEMPLATE)
        .filter(x => {
            return ((state.entities.notes.PTGOALTEMPLATE[x].NoteId == noteId));
        }).length > 0) {
        isTemplateVisible = true;
    }
    
    if (noteType === 1 || noteType === 3 || noteType === 5) {
        disabled = false;
    }

    let defaultLongDate = state.ui.notes[noteId].defaultLongDate;



    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;

    let allGoals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return (
                (noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)
            ) &&
                (state.entities.notes.PTGOALS[key].GODELETED !== true ||
                    (state.entities.notes.PTGOALS[key].GODELETED === true && state.entities.notes.PTGOALS[key].GOGONO)
                )
        })
        .sort((a, b) => {
            return state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO;
        })
        .map(key => state.entities.notes.PTGOALS[key]);


    return {
        noteId: noteId,
        noteType: noteType,
        pk: pk,
        isWc: isWc,
        goalsUpdated,
        defaultLongDate,
        disabled,
        allGoals,
        isTemplateVisible
    };
}

const connectedPatientCareCenterNoteGoalsLTGs = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsLTGs);
export { connectedPatientCareCenterNoteGoalsLTGs as PatientCareCenterNoteGoalsLTGs };

